import React, { useState } from 'react';
import {
  Box,
  Typography,
  Link,
} from '@mui/material';
import CommonButton from '../../common/components/CommonButton';
import CommonFormField from '../../common/components/CommonFormField';
import { validateEmail } from '../../common/const';
import { useLocation } from 'react-router-dom';

const ForgotPasswordForm = ({ onSubmit, loading }) => {
  const location = useLocation();
  const [formData, setFormData] = useState({
    email: ''
  });
  const [errors, setErrors] = useState({});

  const validateField = (name, value) => {
    switch (name) {
      case 'email':
        if (!value) return 'Email is required';
        if (!validateEmail(value)) return 'Please enter a valid email address';
        return '';
      default:
        return '';
    }
  };

  const validateForm = () => {
    const newErrors = {};
    Object.keys(formData).forEach(key => {
      if (key !== 'rememberMe') {
        const error = validateField(key, formData[key]);
        if (error) newErrors[key] = error;
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      const error = validateField(name, value);
      if (!error) {
        setErrors(prev => ({ ...prev, [name]: undefined }));
      } else {
        setErrors(prev => ({ ...prev, [name]: error }));
      }
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);
    if (error) {
      setErrors(prev => ({ ...prev, [name]: error }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    onSubmit(formData);
  };


  return (
    <Box
      sx={{
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflowY: 'auto',
      }}
    >
      <Box sx={{
        width: '100%',
        maxWidth: {
          sm: '400px',   // Small screens
          md: '400px',
          lg: '500px'
        }
      }}>
        <Box sx={{ mb: 2, textAlign: 'center' }}>
          <Typography variant="h4" sx={{ fontWeight: 600, fontSize: '24px' }}>
            Forgot Your Password?
          </Typography>
          <Box>
            <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 400, color: 'text.main' }}>
              Please enter the email address associated with your account and We will email you a link to reset your password.
            </Typography>
          </Box>
        </Box>

        <form onSubmit={handleSubmit}>
          <Box sx={{ mb: 2 }}>
            <CommonFormField
              label="Email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              onBlur={handleBlur}
              placeholder="Please enter your email id"
              error={errors.email}
              loading={loading}
            />
          </Box>

          <CommonButton
            label="Submit"
            size="large"
            type="submit"
            disabled={loading}
          />

          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              Password Remember?{' '}
              <Link href={location.search.split('=')[1] === 'hub' ? "/mentor" : "/login"} variant="body2" color="secondary.main" sx={{ fontWeight: 600, textDecoration: 'none' }}>
                Sign In
              </Link>
            </Typography>
          </Box>
        </form>
      </Box>
    </Box>
  );
};

export default ForgotPasswordForm;